// Moved from core https://git.hubteam.com/HubSpot/automation-ui-core/blob/ceda771c89e5d0c48cff7ee58f3cae3177237d66/automation-ui-references/static/js/object-type-properties/PropertyFieldTypes.ts

// Flattens the type / fieldType into a single type to render input.
// Check out the comment above convertToAddonFieldType in propertyUtils for more info.
const PropertyFieldTypes = {
  BOOL: 'bool',
  CHECKBOX: 'checkbox',
  DATE: 'date',
  DATETIME: 'datetime',
  ENUM: 'enumeration',
  MULTI_LINE_STRING: 'textarea',
  NUMBER: 'number',
  PROPERTY: 'property',
  RADIO: 'radio',
  SINGLE_LINE_STRING: 'text',
  HTML: 'html',
  PHONE_NUMBER: 'phonenumber',
  CALCULATION_SCORE: 'calculation_score',
  CALCULATION_ROLLUP: 'calculation_rollup',
  CALCULATION_EQUATION: 'calculation_equation'
};
export default PropertyFieldTypes;
export const PropertyFieldTypeList = Object.values(PropertyFieldTypes);